import { useRef } from "react";
import { Button } from "../button";
import { FormLabel } from "../form-label";
import { DFlexResponsive } from "../d-flex-responsive";
import SignatureCanvas from "react-signature-canvas";

export function DigitalSignature({
  label = "",
  penColor = "#000000",
  onWrite = () => {},
  filename = "signature.png",
}) {
  const signatureRef = useRef();

  async function handleEnd() {
    const response = await fetch(
      signatureRef.current.getTrimmedCanvas().toDataURL("image/png")
    );

    const blob = await response.blob();

    const file = new File([blob], filename, { type: blob.type });

    onWrite(file);
  }

  function handleClear() {
    signatureRef.current.clear();

    onWrite(null);
  }

  return (
    <>
      <FormLabel label={label} />

      <DFlexResponsive justifyContent="center" alignItems="center">
        <SignatureCanvas
          ref={signatureRef}
          clearOnResize={false}
          penColor={penColor}
          velocityFilterWeight={0.9}
          minWidth={0.5}
          maxWidth={1.5}
          canvasProps={{
            width: "auto",
            height: "auto",
            style: { border: "0.5px solid #000000" },
          }}
          onEnd={handleEnd}
        />

        <Button title="Borrar firma" color="warning" onClick={handleClear} />
      </DFlexResponsive>
    </>
  );
}
